import {
  formatZonedDateKey,
  getWeekBucketKey,
  resolveWorkspaceTimeZone,
  zonedTimeToUtc,
} from './repeat/keys'

export function getWorkspaceTodayIso(
  timeZone?: string,
  now: Date = new Date(),
): string {
  const tz = resolveWorkspaceTimeZone(timeZone)
  return formatZonedDateKey(now, tz)
}

export function getWorkspaceWeekKey(
  timeZone?: string,
  now: Date = new Date(),
): string {
  const tz = resolveWorkspaceTimeZone(timeZone)
  return getWeekBucketKey(now, tz)
}

export function getWorkspaceOccurrenceKey(
  mode: 'DAILY' | 'WEEKLY' | 'INDIVIDUAL',
  timeZone?: string,
  now: Date = new Date(),
): string {
  if (mode === 'WEEKLY') {
    return getWorkspaceWeekKey(timeZone, now)
  }
  return getWorkspaceTodayIso(timeZone, now)
}

export function isWorkspaceDayDifferentFromDevice(
  workspaceTimeZone?: string,
  deviceTimeZone?: string,
  now: Date = new Date(),
): boolean {
  const wsTz = resolveWorkspaceTimeZone(workspaceTimeZone)
  const devTz = deviceTimeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone
  const wsDay = formatZonedDateKey(now, wsTz)
  const devDay = formatZonedDateKey(now, devTz)
  return wsDay !== devDay
}

export function formatWorkspaceDayLabel(
  workspaceTimeZone?: string,
  now: Date = new Date(),
): string {
  const tz = resolveWorkspaceTimeZone(workspaceTimeZone)
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: tz,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  })
  return formatter.format(now)
}

export function calculateMsUntilWorkspaceMidnight(
  timeZone?: string,
  now: Date = new Date(),
): number {
  const tz = resolveWorkspaceTimeZone(timeZone)
  const todayIso = formatZonedDateKey(now, tz)
  const [y, m, d] = todayIso.split('-').map(Number)
  const nextMidnightUtc = zonedTimeToUtc(y, m, d + 1, 0, 0, 0, 0, tz)
  return Math.max(0, nextMidnightUtc.getTime() - now.getTime())
}
